// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.layout-pref-content {
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-bottom: 50px;
}

.layout-pref-section {
  margin-bottom: 8px;
}
.layout-pref-section__title {
  margin: 0 0 8px;
  padding: 0 2px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--ion-color-medium, #666);
}
.layout-pref-section__description {
  margin: 0 0 12px;
  padding: 0 2px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--ion-color-medium, #666);
}

.layout-pref-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  align-items: stretch;
  padding-top: 4px;
}

@media (max-width: 380px) {
  .layout-pref-options {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
.layout-choice {
  margin: 0;
  min-width: 0;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  text-align: left;
  background: var(--ion-item-background, #fff);
  border: 2px solid var(--ion-color-light-shade, #e5e5e5);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
  /* Preview stage: wireframe sits like a screenshot, not squeezed in a list row */
}
.layout-choice--selected {
  border-color: #ed143d;
  box-shadow: 0 2px 12px rgba(237, 20, 61, 0.12), 0 0 0 1px rgba(237, 20, 61, 0.08);
}
.layout-choice--disabled {
  opacity: 0.65;
  pointer-events: none;
  cursor: default;
}
.layout-choice:active:not(.layout-choice--disabled) {
  transform: scale(0.995);
}
.layout-choice__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 10px 8px;
  border-bottom: 1px solid var(--ion-color-light-shade, #eee);
}
.layout-choice__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--ion-text-color, #000);
  flex: 1;
  min-width: 0;
  line-height: 1.25;
}
.layout-choice__radio {
  flex-shrink: 0;
  margin: 0;
  --color: #ed143d;
  --color-checked: #ed143d;
}
.layout-choice__preview {
  padding: 10px 8px 12px;
  background: linear-gradient(180deg, #f8f8f9 0%, #f0f0f2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
}
.layout-choice__preview--compact {
  padding: 12px 8px;
}
.layout-choice__desc {
  margin: 0;
  padding: 10px 10px 12px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--ion-color-medium, #666);
}

/* —— Card wireframe —— */
.wireframe--card {
  display: flex;
  width: 100%;
  max-width: none;
  min-height: 102px;
  border-radius: 10px;
  overflow: hidden;
  background: var(--ion-item-background, #fff);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
}

.wf-card__accent {
  width: 6px;
  flex-shrink: 0;
  background: var(--ion-color-success, #2dd36f);
}

.wf-card__body {
  flex: 1;
  padding: 8px 8px 6px;
  min-width: 0;
}

.wf-card__header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wf-card__avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(135deg, #e8e8e8 0%, #d0d0d0 100%);
}

.wf-card__titles {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.wf-card__loc {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
}

.wf-pin {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #ed143d;
  box-shadow: 0 0 0 2px rgba(237, 20, 61, 0.2);
}
.wf-pin--sm {
  width: 6px;
  height: 6px;
}

.wf-bar {
  height: 8px;
  border-radius: 3px;
  background: #e0e0e0;
}
.wf-bar--lg {
  width: 72%;
  height: 11px;
}
.wf-bar--sm {
  width: 48%;
  height: 7px;
  background: #ececec;
}
.wf-bar--md {
  flex: 1;
  height: 7px;
  max-width: 88%;
}
.wf-bar--loc {
  flex: 1;
  height: 6px;
  max-width: 85%;
  background: #d8d8d8;
}
.wf-bar--loc-sm {
  flex: 1;
  min-width: 0;
  height: 5px;
  max-width: 55%;
  background: #ccc;
}
.wf-bar--subject {
  flex: 1;
  height: 10px;
  max-width: 75%;
  background: #c8c8c8;
}
.wf-bar--time {
  width: 36px;
  height: 6px;
  background: #bbb;
}

.wf-card__rows {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wf-detail-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wf-ico {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
  background: #e8e8e8;
  border: 1px solid #ddd;
}

.wf-card__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.wf-chip {
  border-radius: 10px;
  flex-shrink: 0;
}
.wf-chip--ok {
  width: 48px;
  height: 14px;
  background: rgba(45, 211, 111, 0.35);
  border: 1px solid rgba(45, 211, 111, 0.5);
}
.wf-chip--muted {
  width: 40px;
  height: 14px;
  background: #ececec;
  border: 1px solid #ddd;
}
.wf-chip--mini {
  width: 36px;
  height: 14px;
  border-radius: 4px;
  background: rgba(45, 211, 111, 0.3);
  border: 1px solid rgba(45, 211, 111, 0.4);
}

/* —— Stack wireframe —— */
.wireframe--stack {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
  max-width: none;
  min-height: 52px;
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid var(--ion-color-light-shade, #e0e0e0);
  background: var(--ion-item-background, #fff);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.wf-stack__left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.wf-stack__subject-row {
  display: flex;
  align-items: center;
  gap: 5px;
}

.wf-repeat {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 2px;
  border: 2px solid #bbb;
  background: repeating-linear-gradient(90deg, transparent, transparent 2px, #ccc 2px, #ccc 3px);
}

.wf-stack__loc-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wf-stack__end {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  padding-left: 4px;
  border-left: 1px solid #eee;
}

.wf-clock {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #999;
  flex-shrink: 0;
  position: relative;
}
.wf-clock::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 6px;
  width: 1px;
  height: 4px;
  background: #999;
}
.wf-clock::before {
  content: "";
  position: absolute;
  top: 6px;
  left: 6px;
  width: 3px;
  height: 1px;
  background: #999;
}

.wf-stack__times {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/layout-preferences-modal/layout-preferences-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,qBAAA;EACA,mBAAA;EACA,sBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;AAAE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,oCAAA;AAEJ;AACE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;AACJ;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AAAF;;AAGA;EACE;IACE,0BAAA;IACA,SAAA;EAAF;AACF;AAGA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,4CAAA;EACA,uDAAA;EACA,yCAAA;EACA,8EACE;EAgDF,gFAAA;AAjDF;AAKE;EACE,qBAAA;EACA,iFACE;AAJN;AAQE;EACE,aAAA;EACA,oBAAA;EACA,eAAA;AANJ;AASE;EACE,uBAAA;AAPJ;AAUE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,sBAAA;EACA,2DAAA;AARJ;AAWE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kCAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;AATJ;AAYE;EACE,cAAA;EACA,SAAA;EACA,gBAAA;EACA,wBAAA;AAVJ;AAcE;EACE,sBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAZJ;AAcI;EACE,iBAAA;AAZN;AAiBE;EACE,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;AAfJ;;AAmBA,yBAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,wEACE;AAjBJ;;AAqBA;EACE,UAAA;EACA,cAAA;EACA,6CAAA;AAlBF;;AAqBA;EACE,OAAA;EACA,oBAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,6DAAA;AAlBF;;AAqBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,4CAAA;AAlBF;AAoBE;EACE,UAAA;EACA,WAAA;AAlBJ;;AAsBA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,UAAA;EACA,YAAA;AAnBJ;AAsBE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AApBJ;AAuBE;EACE,OAAA;EACA,WAAA;EACA,cAAA;AArBJ;AAwBE;EACE,OAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,OAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,OAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAxBJ;AA2BE;EACE,WAAA;EACA,WAAA;EACA,gBAAA;AAzBJ;;AA6BA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,mBAAA;EACA,cAAA;AA1BF;AA4BE;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,yCAAA;AA1BJ;AA6BE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AA3BJ;AA8BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,yCAAA;AA5BJ;;AAgCA,0BAAA;AACA;EACE,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uDAAA;EACA,4CAAA;EACA,yCAAA;AA7BF;;AAgCA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,8FAAA;AA7BF;;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,2BAAA;AAnCF;;AAsCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAnCF;AAqCE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AApCJ;;AAwCA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AArCF","sourcesContent":[".layout-pref-content {\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --padding-bottom: 50px;\n}\n\n.layout-pref-section {\n  margin-bottom: 8px;\n\n  &__title {\n    margin: 0 0 8px;\n    padding: 0 2px;\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: var(--ion-color-medium, #666);\n  }\n\n  &__description {\n    margin: 0 0 12px;\n    padding: 0 2px;\n    font-size: 13px;\n    line-height: 1.4;\n    color: var(--ion-color-medium, #666);\n  }\n}\n\n.layout-pref-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  align-items: stretch;\n  padding-top: 4px;\n}\n\n@media (max-width: 380px) {\n  .layout-pref-options {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n\n.layout-choice {\n  margin: 0;\n  min-width: 0;\n  border-radius: 16px;\n  overflow: hidden;\n  cursor: pointer;\n  text-align: left;\n  background: var(--ion-item-background, #fff);\n  border: 2px solid var(--ion-color-light-shade, #e5e5e5);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.15s ease;\n\n  &--selected {\n    border-color: #ed143d;\n    box-shadow:\n      0 2px 12px rgba(237, 20, 61, 0.12),\n      0 0 0 1px rgba(237, 20, 61, 0.08);\n  }\n\n  &--disabled {\n    opacity: 0.65;\n    pointer-events: none;\n    cursor: default;\n  }\n\n  &:active:not(.layout-choice--disabled) {\n    transform: scale(0.995);\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 10px 10px 8px;\n    border-bottom: 1px solid var(--ion-color-light-shade, #eee);\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    color: var(--ion-text-color, #000);\n    flex: 1;\n    min-width: 0;\n    line-height: 1.25;\n  }\n\n  &__radio {\n    flex-shrink: 0;\n    margin: 0;\n    --color: #ed143d;\n    --color-checked: #ed143d;\n  }\n\n  /* Preview stage: wireframe sits like a screenshot, not squeezed in a list row */\n  &__preview {\n    padding: 10px 8px 12px;\n    background: linear-gradient(180deg, #f8f8f9 0%, #f0f0f2 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 140px;\n\n    &--compact {\n      padding: 12px 8px;\n\n    }\n  }\n\n  &__desc {\n    margin: 0;\n    padding: 10px 10px 12px;\n    font-size: 12px;\n    line-height: 1.4;\n    color: var(--ion-color-medium, #666);\n  }\n}\n\n/* —— Card wireframe —— */\n.wireframe--card {\n  display: flex;\n  width: 100%;\n  max-width: none;\n  min-height: 102px;\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--ion-item-background, #fff);\n  box-shadow:\n    0 2px 8px rgba(0, 0, 0, 0.08),\n    0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.wf-card__accent {\n  width: 6px;\n  flex-shrink: 0;\n  background: var(--ion-color-success, #2dd36f);\n}\n\n.wf-card__body {\n  flex: 1;\n  padding: 8px 8px 6px;\n  min-width: 0;\n}\n\n.wf-card__header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wf-card__avatar {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, #e8e8e8 0%, #d0d0d0 100%);\n}\n\n.wf-card__titles {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.wf-card__loc {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.wf-pin {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: #ed143d;\n  box-shadow: 0 0 0 2px rgba(237, 20, 61, 0.2);\n\n  &--sm {\n    width: 6px;\n    height: 6px;\n  }\n}\n\n.wf-bar {\n  height: 8px;\n  border-radius: 3px;\n  background: #e0e0e0;\n\n  &--lg {\n    width: 72%;\n    height: 11px;\n  }\n\n  &--sm {\n    width: 48%;\n    height: 7px;\n    background: #ececec;\n  }\n\n  &--md {\n    flex: 1;\n    height: 7px;\n    max-width: 88%;\n  }\n\n  &--loc {\n    flex: 1;\n    height: 6px;\n    max-width: 85%;\n    background: #d8d8d8;\n  }\n\n  &--loc-sm {\n    flex: 1;\n    min-width: 0;\n    height: 5px;\n    max-width: 55%;\n    background: #ccc;\n  }\n\n  &--subject {\n    flex: 1;\n    height: 10px;\n    max-width: 75%;\n    background: #c8c8c8;\n  }\n\n  &--time {\n    width: 36px;\n    height: 6px;\n    background: #bbb;\n  }\n}\n\n.wf-card__rows {\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.wf-detail-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wf-ico {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  flex-shrink: 0;\n  background: #e8e8e8;\n  border: 1px solid #ddd;\n}\n\n.wf-card__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.wf-chip {\n  border-radius: 10px;\n  flex-shrink: 0;\n\n  &--ok {\n    width: 48px;\n    height: 14px;\n    background: rgba(45, 211, 111, 0.35);\n    border: 1px solid rgba(45, 211, 111, 0.5);\n  }\n\n  &--muted {\n    width: 40px;\n    height: 14px;\n    background: #ececec;\n    border: 1px solid #ddd;\n  }\n\n  &--mini {\n    width: 36px;\n    height: 14px;\n    border-radius: 4px;\n    background: rgba(45, 211, 111, 0.3);\n    border: 1px solid rgba(45, 211, 111, 0.4);\n  }\n}\n\n/* —— Stack wireframe —— */\n.wireframe--stack {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 6px;\n  width: 100%;\n  max-width: none;\n  min-height: 52px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: 1px solid var(--ion-color-light-shade, #e0e0e0);\n  background: var(--ion-item-background, #fff);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n.wf-stack__left {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n}\n\n.wf-stack__subject-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.wf-repeat {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  border-radius: 2px;\n  border: 2px solid #bbb;\n  background: repeating-linear-gradient(\n    90deg,\n    transparent,\n    transparent 2px,\n    #ccc 2px,\n    #ccc 3px\n  );\n}\n\n.wf-stack__loc-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wf-stack__end {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n  padding-left: 4px;\n  border-left: 1px solid #eee;\n}\n\n.wf-clock {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid #999;\n  flex-shrink: 0;\n  position: relative;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 3px;\n    left: 6px;\n    width: 1px;\n    height: 4px;\n    background: #999;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 6px;\n    left: 6px;\n    width: 3px;\n    height: 1px;\n    background: #999;\n  }\n}\n\n.wf-stack__times {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
